module.exports = __webpack_public_path__ + "img/100.b298dedf.png";